var HelpTrackingKeys;
(function (HelpTrackingKeys) {
    HelpTrackingKeys["trainingWebinars"] = "trainingWebinars";
    HelpTrackingKeys["launching"] = "launchingPerkbox";
    HelpTrackingKeys["customisation"] = "customisation";
    HelpTrackingKeys["peopleManagement"] = "peopleManagement";
    HelpTrackingKeys["billingPayments"] = "billingPayments";
})(HelpTrackingKeys || (HelpTrackingKeys = {}));
export default HelpTrackingKeys;
